<template>
    <div>
        <el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
        <div class="chain_RelatedReport">
            <h2 class="chain_title1">全国{{ baseInfo.title }}竞争格局</h2>
            <div>
                <div class="market-box w95mg oh" v-if="!isChainDetail">
                    <div v-for="(list, i) in competitiveList" :key="i" class="fl market-list mb-2">
                        <h4 class="mt-1 market-title font-16" @click="routerblank('/marketDetail?type=2&id='+list.id)">{{ list.title }}</h4>
                        <div style="width: 90%;height: 290px;margin: 0 auto;" :id="'pie_charts_' + i"></div>
                    </div>
                </div>
                <div class="market-box w95mg"  v-if="isChainDetail">
                    <div class="chain-detail-market oh">
                        <div class="fl chain-detail-box">
                            <div v-for="(list, i) in competitiveList" :key="i" class="fl market-list mb-2">
                                <h4 class="mt-1 market-title font-16" @click="routerblank('/marketDetail?type=2&id='+list.id)">{{ list.title }}</h4>
                                <div style="width: 90%;height: 290px;margin: 0 auto;" :id="'pie_charts_' + i"></div>
                            </div>
                        </div>
                        <div class="fr">
                            <div class="chain_free">
                                <freeUserTips :type="4" :bgtype="42" :isShowDownFile="true"></freeUserTips>
                            </div>
                        </div>
                 </div>
                </div>
			    <!-- <p class="text-center my-2 curp widthPC-100 font-18" @click="routerblank('/industryLibrary?type=3&code='+baseInfo.notionList)">更多信息 ></p> -->
			    <p class="text-center my-2 curp widthPC-100 font-18" @click="freeRtouer()">更多信息 ></p>

            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            isShowFreeUserTips:false,
        }
    },
    props: {
        userdata: { type: Object, default: {} },
        baseInfo:{ type:Object,default:{} },
        competitiveList: { type: Array, default: [] },
        isChainDetail:{type:Boolean,default:false},//是否是产业链详情引用的，产业连详情引用的是要盖住一半提示vip
    },
    mounted() {
        this.init();
    },
    methods: {
        freeRtouer(){
          this.isShowFreeUserTips = true;
        },
        // 获取市场竞争列表
       init(){
        if(this.competitiveList.length > 0){
            this.$nextTick(() => {
            this.competitiveList.forEach((list, i) => {
                this.pieCharts('pie_charts_' + i, list.dataList, list.unit);
            }) 
        })
        }
       } ,
        pieCharts(el, data, unit) {
            // console.log(el,data);
            let seriesData = [];
            var trendchart = echarts.init(document.getElementById(el));
            for (var i = 0; i < data.length; i++) {
                data[i].name = data[i].label;
                if (data[i].label == '其他') {
                    var ortherData = data[i]
                    // console.log(data[i]);
                } else {
                    seriesData.push(data[i]);
                }
            }
            if (typeof ortherData === 'object' && ortherData !== null && Object.keys(ortherData).length > 0) {
                seriesData.push(ortherData);
                // console.log(ortherData,seriesData,data);
            }
            console.log('sererwaerf',seriesData);
            var option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b0}: {c0} ' + unit
                },
                // color: this.colors,
                legend: {
                    right: '0',
                    top: 'center',
                    orient: 'vertical', // 设置图例竖排
                    type: 'scroll', //图例强制不换行（滚动）
                    width: '70%',
                    formatter: (name) => {
                        if (!name) return ''
                        return this.getEqualNewlineString(name, 10) // 根据你的需求修改参数
                    }
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        // radius: ['40%', '70%'],
                        center: ['35%', '50%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        labelLine: {
                            show: false
                        },
                        data: seriesData,
                        itemStyle: {
                            normal: {
                                borderColor: '#ffffff', // 发光颜色
                                // borderWidth: 5,       // 发光宽度
                                // shadowBlur: 10,       // 阴影模糊大小
                                // shadowColor: '#f7f3ff'  // 阴影颜色
                            }
                        },
                    }
                ],
            };
            trendchart.setOption(option);
            // 饼图点击跳转到指定页面
            trendchart.on('click', (param) => {
                console.log(param)
                if (param.data.stockCode != '' && param.data.table != 0) {
                    if (param.data.table != 4) {
                        this.routerlinkid('/enterprises', param.data.stockCode);
                    } else {
                        this.routerlinkid('/enterprisesF', param.data.stockCode);
                    }
                }
                // window.location.href = param.data.url;
            });
        },
        getEqualNewlineString (params, length) {
		let text = ''
		let count = Math.ceil(params.length / length) // 向上取整数
		// 一行展示length个
		if (count > 1) {
			for (let z = 1; z <= count; z++) {
			text += params.substr((z - 1) * length, length)
			if (z < count) {
				text += '\n'
			}
			}
		} else {
			text += params.substr(0, length)
		}
		return text
		},
    }
}
</script>
<style lang="scss" scoped>
.chain-detail-market{
    .chain-detail-box{
        width:462px;
        .market-list{
            width: 100%;
        }
    }
}
.chain_free{
    width: 1000px;
    height: 780px;
    .freeUserTips{
        height: 770px;
    }
}
.container-flex-center img{
	max-width: 95%;
	max-height: 95%;
}
.el-dialog__headerbtn{
	font-size: 30px;
	font-weight: bold;
}
.pop-box{
	width:100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	border: 1px solid red;
	z-index: 99999;
}
.market-list{
	width: calc(33% - 35px);
    height: 365px;
    cursor: pointer;
    overflow: hidden;
    transition: all .3s;
    border: 1px solid #eee;
    margin-right: 35px;
    border-radius: 8px;
}
.market-list:hover{
	/* background: #f3f7ff; */
	border-radius: 8px;

}
.image-card{
	height: 270px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.market-title{
	padding: 20px 20px 0 20px;
	height: 48px;
	/* display: flex; */
    /* align-items: center; */
	/* overflow: hidden; */
}
</style>